export default function SystemSettingsPage() {
  return (
    <div className="space-y-5 max-w-[1440px] mx-auto">
      <h1 className="text-xl font-bold text-foreground-900" style={{ fontFamily: "var(--font-heading)" }}>
        系統設定
      </h1>
      <div className="bg-background-50 border border-background-200 rounded-xl p-8 text-center">
        <div className="w-16 h-16 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-4">
          <i className="ri-settings-3-line text-primary-500 text-2xl" />
        </div>
        <h2 className="text-lg font-semibold text-foreground-900 mb-2">系統設定</h2>
        <p className="text-sm text-foreground-500">此頁面將顯示平台系統參數、語言設定與自動流程配置</p>
      </div>
    </div>
  );
}